export default __webpack_public_path__ + "static/media/cupcake-3.57e65157.jpg";